<template>
	<div class="personHome d-flex j-sb a-start">
		<!-- 左侧产品列表 -->
		<div class="psLeftContent">
			<div class="topInfo bd10 p3 d-flex j-sb a-center">
				<div class="lAvatar d-flex a-center">
					<figure :style="'background-image: url('+$store.state.avatar+')'" class="pr">
						<el-upload
						  class="avatar-uploader ab"
						  action="/api/common/file/upload"
						  :multiple="false"
						  :show-file-list="false"
						  :on-success="handleAvatarSuccess"
						  :before-upload="beforeAvatarUpload"
						  :headers="{'InterfaceToken': $store.state.InterfaceToken}">
						</el-upload>
					</figure>
					<div class="text line-sm">
						<h3 class="font20">{{formData.sexual}}{{formData.name}}</h3>
						<p class="font14 cor999">Site ID:{{formData.siteId}}</p>
					</div>
				</div>
				<div class="email font14 line-sm">
					<span>{{$t('commom.email')}}</span><br>
					{{formData.email}}
				</div>
			</div>
			<!-- 表单 -->
			<div class="form bd10 p3">
				<div class="sTitle d-flex a-center j-sb">
					 <h3 class="font20">{{ $t('admin.basicInformation') }}</h3>
				</div>
				<dl>
					<dd class="d-flex f-colu">
						<div class="label font-medium">{{$t('register.company')}}</div>
						<div class="enter d-flex">
							<input type="text" v-model="formData.company" class="input font-light" :placeholder="$t('register.companyPlaceholder')">
						</div>
					</dd>
					<dd class="d-flex j-sb">
						<div class="item">
							<div class="label font-medium">{{$t('register.surname')}}</div>
							<div class="enter">
								<input type="text" v-model="formData.sexual" class="input font-light" :placeholder="$t('register.surnamePlaceholder')">
							</div>
						</div>
						<div class="item">
							<div class="label font-medium">{{$t('register.name')}}</div>
							<div class="enter">
								<input type="text" v-model="formData.name" class="input font-light" :placeholder="$t('register.namePlaceholder')">
							</div>
						</div>
					</dd>
					<dd class="d-flex j-sb">
						<div class="item">
							<div class="label font-medium">{{$t('register.country')}}</div>
							<div class="enter">
								<select v-model="formData.country" name="" id="" @change="getCurrentProvince" class="input font-light">
									<option value="">{{$t('register.countryPlaceholder')}}</option>
									<option :value="item.name" v-for="(item, index) in countryList" :key="index">{{item.name}}</option>
								</select>
							</div>
						</div>
						<div class="item">
							<div class="label font-medium">{{$t('register.province')}}</div>
							<div class="enter">
								<select v-model="formData.province" name="" id="" @change="getCurrentCity" class="input font-light">
									<option value="">{{$t('register.provincePlaceholder')}}</option>
									<option :value="item.name" v-for="(item, index) in provinceList" :key="index">{{item.name}}</option>
								</select>
							</div>
						</div>
					</dd>
					<dd class="d-flex j-sb">
						<div class="item">
							<div class="label font-medium">{{$t('register.city')}}</div>
							<div class="enter">
								<select v-model="formData.city" name="" id="" class="input font-light">
									<option value="">{{$t('register.cityPlaceholder')}}</option>
									<option :value="item.name" v-for="(item, index) in cityList" :key="index">{{item.name}}</option>
								</select>
							</div>
						</div>
						<div class="item">
							<div class="label font-medium">{{$t('register.encoded')}}</div>
							<div class="enter">
								<input type="text" v-model="formData.postalCode" class="input font-light" :placeholder="$t('register.encodedPlaceholder')">
							</div>
						</div>
					</dd>
					<dd class="d-flex f-colu">
						<div class="label font-medium">{{$t('register.address')}}</div>
						<div class="enter">
							<input type="text" v-model="formData.address" class="input font-light" :placeholder="$t('register.addressPlaceholder')">
						</div>
					</dd>
					<dd class="d-flex f-colu">
						<div class="label font-medium">{{$t('register.companyAddress')}}</div>
						<div class="enter">
							<input type="text" v-model="formData.companyAddress" class="input font-light" :placeholder="$t('register.companyAddressPlaceholder')">
						</div>
					</dd>
					<dd class="d-flex f-colu">
						<div class="label font-medium">{{$t('register.contact')}}</div>
						<div class="enter">
							<input type="text" v-model="formData.contact" class="input font-light" :placeholder="$t('register.contactPlaceholder')">
						</div>
					</dd>
				</dl>

			</div>
			<div class="submit">
				<button class="fmBtn pointer" @click="submitForm">{{$t('register.save')}}</button>
			</div>
		</div>

		<!-- 右侧推荐产品 -->
		<div class="rightGuide ">
			<!-- 感兴趣的产品 -->
			<div class="products bd10 p3">
				<div class="sTitle d-flex a-center j-sb">
					 <h3 class="font20">{{$t('admin.productsOfInterest')}}</h3>
				</div>
				<div class="interest">
					<ul class="d-flex f-wrap">
						<li @click="changeProduct(item.value)" :class="{active: productTagChecked(item.value)}" v-for="(item, index) in $store.state.productTagList" :key="index">
							<p class="pointer font-light line-sm link"><span class="pr"></span>{{item.label}}</p>
						</li>
					</ul>
				</div>
			</div>
			<!-- 订阅 -->
			<div class="subscribe d-flex j-sb a-center bd10 p3">
				<div class="sTitle d-flex a-center j-sb">
					 <h3 class="font20">{{$t('admin.isSubscribe')}}</h3>
				</div>
				<div :class="['swich pr pointer', {active: formData.isSubscribe}]" @click="updateSubscribe">
					<span class="t-sion"></span>
					<input type="checkbox" class="ab opacity0 pointer">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// vuex
import { mapMutations,mapState } from 'vuex'
export default {
  name: 'PersonInformation',
  components: {

  },
  data() {
    return {
		// 个人信息
		formData: {},
		productTag: [], // 个人感兴趣产品
		countryList: [], // 国家列表
		provinceList: [], // 省份列表
		cityList: [], // 城市列表
	}
  },

  computed: {
		// 感兴趣产品选中
		productTagChecked: function() {
			return function(value) {
				return this.productTag.includes(value) ? true : false;
			}
		}
  },

  async created() {
	  // 获取国家
	  await this.getCountryList();
	  this.formData = this.$store.state.member;
	  this.productTag = this.formData.productTag.split(',');
	  // 获取省份
	  let current = this.countryList.filter(f => {return f.name == this.formData.country});
	  this.$axios.get(`common/select/province?countryNo=${current[0].id}`)
	  .then(res => {
	  	this.provinceList = res.data;
		// 获取城市
		let currentCity = this.provinceList.filter(c => {return c.name == this.formData.province});
		this.$axios.get(`common/select/city?provinceNo=${currentCity[0].id}`)
		.then(res => {
			this.cityList = res.data;
		})
		.catch(err => {});
	  })
	  .catch(err => {});

  },

  methods: {
	  // vuex
	  ...mapMutations(['changeState']),

	  // 获取国家
	  async getCountryList() {
		let res = await this.$axios.get(`common/select/country`);
		this.countryList = res.data;
	  },

	  // 根据选择国家显示对应省份
	  getCurrentProvince() {
	  		  // 清空省份城市
	  		  this.formData.province = '';
	  		  this.formData.city = '';
	  		let current = this.$store.state.countryList.filter(f => {return f.name == this.formData.country});
	  		this.$axios.get(`common/select/province?countryNo=${current[0].id}`)
	  		.then(res => {
	  			this.provinceList = res.data;
	  		})
	  		.catch(err => {});
	  },

	  // 根据选择省份显示对应城市
	  getCurrentCity() {
	  		  // 清空城市
	  		  this.formData.city = '';
	  		let current = this.provinceList.filter(f => {return f.name == this.formData.province});
	  		this.$axios.get(`common/select/city?provinceNo=${current[0].id}`)
	  		.then(res => {
	  			this.cityList = res.data;
	  		})
	  		.catch(err => {});
	  },

	  // 是否订阅感兴趣的内容推送
	  updateSubscribe() {
      this.formData.isSubscribe = this.formData.isSubscribe ? false : true;
      let that = this;
		 this.$axios({
			  method: 'post',
			  url: 'member/updateBasic',
			  data: this.formData,
		 }).then(res => {
			 if(this.formData.isSubscribe) {
				 this.$message.success(this.$t('admin.subscribed'));
			 }else{
				 this.$message.success(this.$t('admin.unsubscribe'));
			 }
       that.changeState({
			 	member: that.formData
			 })
			 // 更新存储用户信息
       localStorage.setItem("member", JSON.stringify(that.formData));
			 sessionStorage.setItem("member", JSON.stringify(that.formData));
       // 修改store
       that.changeState({
         member: that.formData
       });
		 })
		 .catch(err => {});
	  },

	  // 保存提交
	  submitForm() {
      let that = this;
		  // 接口
		  this.$axios({
			  method: 'post',
			  url: 'member/updateBasic',
			  data: this.formData,
		  }).then(res => {
			  this.$message.success(this.$t('commom.saveSuccess'));
			  // 更新存储用户信息
        localStorage.setItem("member", JSON.stringify(that.formData));
			  sessionStorage.setItem("member", JSON.stringify(that.formData));
        // 修改store
        that.changeState({
          member: that.formData
        });
		  })
		  .catch(err => {});
	  },


	  // 修改感兴趣产品
	  changeProduct(value) {
      let that = this;
		  if(this.productTag.includes(value)) {
			  let index = this.productTag.indexOf(value);
			  this.productTag.splice(index, 1);
		  }else{
			this.productTag.push(value);
		  }
		  this.formData.productTag = this.productTag.join(',');
		  // 接口
		  this.$axios({
			  method: 'post',
			  url: 'member/updateBasic',
			  data: that.formData,
		  }).then(res => {
			  // 更新存储用户信息
        localStorage.setItem("member", JSON.stringify(that.formData));
			  sessionStorage.setItem("member", JSON.stringify(that.formData));
        // 修改store
        that.changeState({
          member: that.formData
        });
		  })
		  .catch(err => {});
	  },

	  // 头像上传前进行验证
	  beforeAvatarUpload(file) {
		  this.beforeAvatarUploadCommon(file);
	  },

	  // 上传成功
	  handleAvatarSuccess(response) {
      let that = this;
		  if(response.code == 500) {
			  this.$message.error(this.$t('commom.sysErr'))
		  }
		  this.formData.cover = response.data;
		  this.changeState({
			  avatar: response.data
		  });
		  this.$axios({
			  method: 'post',
			  url: 'member/updateBasic',
			  data: that.formData,
		  }).then(res => {
			  sessionStorage.setItem("avatar", response.data);
			  // 更新存储用户信息
        localStorage.setItem("member", JSON.stringify(that.formData));
			  sessionStorage.setItem("member", JSON.stringify(that.formData));
        // 修改store
        that.changeState({
          member: that.formData
        });
		  })
		  .catch(err => {});
	  }
  }
}
</script>

<style lang="less" scoped>
	.personHome{
		margin: 0 -.1rem;
		> div{
			padding: 0 .1rem;
		}
		.rightGuide{
			width: 36.875%;
			.interest{
				margin-top: -.2rem;
				height: 3.47rem;
				overflow: auto;
				ul{
					li{
						width: 33.33%;
					}
				}
			}
			.subscribe{
				margin-top: .2rem;
				.sTitle{
					margin-bottom: 0;
				}
			}
		}
		.psLeftContent{
			width: 63.125%;
			.submit{
				margin-top: .3rem;
				button{
					width: 1.2rem;
				}
			}
			.form{

				dl{
					max-width: 530px;
					dd{
						.label{
							margin-bottom: .1rem;
						}
						&:not(:last-child) {
							margin-bottom: .3rem;
						}
						.fmBtn{
							width: 1.1rem;
						}
						.input,.fmBtn{
							border-radius: 0;
						}
						.code .input{
							width: calc(100% - 1.1rem);
						}
						.item{
							width: 48%;
						}
					}
				}
			}
			.topInfo{
				margin-bottom: .2rem;
				.email{
					text-align: right;
					span{
						padding-left: .2rem;
						background: url(@/assets/Icons/email.png) no-repeat 0 center/.16rem;
					}
				}
				figure{
					width: .7rem;
					height: .7rem;
					border-radius: 50%;
					background: url(@/assets/Admin/avatar.png) no-repeat center/cover;
					margin-right: .2rem;
				}
			}
		}
		@media (max-width: 1200px) {
			display: block;

			>div{
				padding: 0;
			}
			.psLeftContent,
			.rightGuide{
				width: 100%;
			}
			.rightGuide{
				margin-top: .5rem;
			}
		}
		@media (max-width: 640px) {
			padding: .2rem;
			.psLeftContent{
				.topInfo{
					display: block;
					margin-bottom: .2rem;
					.email{
						text-align: center;
						margin-top: 0.2rem;
					}
				}
			}

		}
	}
</style>
